import Clipboard from 'clipboard';

/* eslint no-new: 0 */
export default function copyTextButton(copyBtnSelector = '.copy-key-btn') {
  new Clipboard(copyBtnSelector);
  this.$(copyBtnSelector).tooltip({ title: 'Copied!', trigger: 'click' });
  this.$(copyBtnSelector).on('shown.bs.tooltip', e => {
    const target = e.currentTarget;
    window.setTimeout(() => {
      $(target).tooltip('hide');
    }, 750);
  });
}



// WEBPACK FOOTER //
// ./utils/buttons.js